import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "introduction"
    }}>{`Introduction`}</h1>
    <p>{`Thank you for joining the community of developers worldwide that are creating add-ons for Adobe Express.`}</p>
    <h2 {...{
      "id": "guideline-categories"
    }}>{`Guideline Categories`}</h2>
    <p>{`Adobe's goal is to publish high-quality add-ons. With that goal in mind, we’ve created this set of guidelines to give you some tips on best practices, and ensure you take the right steps to get your add-on approved:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./general/"
        }}>{`General guidelines`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./brand_guidelines.md"
        }}>{`Adobe Express Developer Program brand guidelines`}</a>{` (aka: "Developer Brand Guidelines" throughout these guides)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./monetization.md"
        }}>{`Monetization guidelines`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./genai/"
        }}>{`Generative AI guidelines`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      